module.exports = __webpack_public_path__ + "img/index_04.91b52b46.png";